import styled from "styled-components";
import { StyledPrimaryButton } from "@/components/uielements/primaryButton/styles";
import { LAYOUT, ORDER } from "@/constants/styles";
import { getFontStyles } from "@/redux/cmsConfig/utils";

interface StyledExpandedMessageContainerProps {
  backgroundImage?: string;
}

export const StyledExpandedMessageContainer =
  styled.div<StyledExpandedMessageContainerProps>(
    ({ theme, backgroundImage }) => ({
      border: `solid 1px ${theme.auth_page.border_color ?? "transparent"}`,
      borderRadius: `${theme.auth_page.border_radius ?? 0}px ${
        theme.auth_page.border_radius ?? 0
      }px 0 0`,
      height: `calc(100vh - ${LAYOUT.HEADERHEIGHT}px - ${LAYOUT.LOYALTY_MENU_HEIGHT_DESKTOP}px - ${LAYOUT.GUTTER}px)`,
      overflowY: "scroll",
      position: "absolute",
      right: "20px",
      top: "20px",
      width: `calc(${LAYOUT.MAX_LOYALTY_CONTAINER_WIDTH}px - 35% - ${
        LAYOUT.GUTTER * 2
      }px)`,
      zIndex: `${ORDER.LOYALTY_HEADER - 1}`,
      "-webkit-overflow-scrolling": "touch",
      ...getFontStyles(theme.auth_page.font),

      "> div": {
        background: theme.auth_page.background_color ?? "transparent",
        padding: "20px",
      },

      "@media (min-width: 768px)": {
        backgroundImage: backgroundImage ? `url(${backgroundImage})` : "none",
        padding: backgroundImage ? "20px" : 0,
      },

      [`@media (max-width: ${LAYOUT.MAX_LOYALTY_CONTAINER_WIDTH}px)`]: {
        width: `calc(100% - 35% - ${LAYOUT.GUTTER * 2}px)`,
      },

      "@media (max-width: 767px)": {
        background: theme.auth_page.background_color ?? "transparent",
        borderRadius: 0,
        height: `calc(
        100vh - ${LAYOUT.MOBILE_HEADERHEIGHT}px -
          ${LAYOUT.LOYALTY_MENU_HEIGHT_MOBILE}px
      )`,
        position: "fixed",
        top: `calc(
        ${LAYOUT.MOBILE_HEADERHEIGHT}px + ${LAYOUT.LOYALTY_MENU_HEIGHT_MOBILE}px
        )`,
        right: 0,
        width: "100%",

        "> div": {
          padding: "10px 10px 120px",
        },
      },
    })
  );

export const StyledExpandedMessageHeader = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "row-reverse",
  justifyContent: "space-between",
  position: "relative",

  h1: {
    margin: 0,
    ...getFontStyles(theme.auth_page.secondary_font),
  },

  "@media (max-width: 767px)": {
    display: "block",
  },
}));

export const StyledExpandedMessageBody = styled.div(({ theme }) => ({
  marginTop: "20px",

  "p, h4, h2": {
    ...getFontStyles(theme.auth_page.font, [
      "color",
      "font_family",
      "font_style",
      "line_height",
    ]),
  },

  p: {
    margin: "0 0 20px",
  },

  "h4, h2": {
    fontSize: "16px",
    fontFamily: theme.primary_font.bold.font_family,
  },

  "img, video": {
    maxWidth: "100%",
  },
}));

export const StyledMessageIcons = styled.div`
  @media (max-width: 767px) {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    width: 100%;
  }
`;

export const StyledMessageIcon = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  font-size: 32px;
  height: 100%;
  line-height: normal;
  padding: 0;

  img {
    height: 24px;
    width: 24px;
  }

  @media (max-width: 767px) {
    padding-right: ${LAYOUT.GUTTER}px;
  }
`;

export const StyledCloseMessageIcon = styled(StyledMessageIcon)`
  @media (min-width: 768px) {
    display: none;
  }

  @media (max-width: 767px) {
    padding: 0 0 0 ${LAYOUT.GUTTER}px;
  }
`;

export const StyledButtonContainer = styled.div`
  a {
    margin-bottom: ${LAYOUT.GUTTER / 2}px;
  }

  @media (min-width: 768px) {
    display: flex;
    justify-content: start;

    a {
      margin: 0 ${LAYOUT.GUTTER * 2}px 0 0;
    }
  }
`;

export const StyledMessageCtas = styled(StyledPrimaryButton)`
  overflow: visible;
`;
